import { getLogin, getUserInfo } from '@/api/user'
import { getToken, setToken,getTokens,setTokens, removeToken,removeTokens, getSafe, setSafe, removeSafe } from '@/utils/auth'
import { resetRouter } from '@/router'
const state = {
    token: getToken(),
    partToken:getTokens(),
    name: '',
    photo: [],
    avatar: '',
    pageAuth: [],
    permissions: [],
    userInfo: {},
    companyName: '',
    security: getSafe(),
    purchaseForm: {}
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_TOKENS: (state, partToken) => {
        state.partToken = partToken
    },
    SET_PHOTO: (state, photo) => {
        state.photo = photo
    },
    SET_PURCHASEORM: (state, data) => {
        state.purchaseForm = data || {}
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_USER_INFO: (state, avatar) => {
        state.userInfo = avatar
        // state.companyName = avatar.orgNodeName
    },
    SET_SECURITY: (state, security) => {
        state.security = security
    },
    SET_PERMISSIONS_AUTH: (state, permissions) => {
        state.permissions = permissions
    }
}

const actions = {
    // 表单
    purchaseForm({ commit }, data) {
        return new Promise(resolve => {
            commit('SET_PURCHASEORM', data)
            resolve()
        })
    },
    photo({ commit }, data) {
        return new Promise(resolve => {
            commit('SET_PHOTO', data)
            resolve()
        })
    },
    // user login
    login({ commit }, userInfo) {
        console.log('userInfo', userInfo)
        return new Promise((resolve, reject) => {
            getLogin(userInfo).then(res => {
                if (res.code) {
                    setToken(res.token)
                    commit('SET_TOKEN', res.token)
                    setTokens(res.partToken)
                    commit('SET_TOKENS', res.partToken)
                    commit('SET_PURCHASEORM', {})

                    // setToken(res.data)
                    // 1 为第一次登录 强制提醒 修改密码   // // 2 为密码 超过90天 要 改密码
                    if (res.code === 1 || res.code === 2) {
                        setSafe(res.code)
                        commit('SET_SECURITY', res.code)
                    }
                    resolve(res)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    // get user info
    getInfo({ commit, state }) {
        return new Promise(async(resolve, reject) => {
            await getUserInfo().then(res => {
                if (res.code === 200) {
                    var u = navigator.userAgent
                    if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) { // 安卓手机
                        console.log(state.token,'liyuyu')
                        window.test.login(res.user.userId,state.token)
                    }
                    commit('SET_USER_INFO', res.user)
                    commit('SET_NAME', res.user.nickName)
                    // if (!res.data.enumOrgCategory || res.data.enumOrgCategory === 1) {
                    // } else if ([4, 8].includes(res.data.enumOrgCategory)) {
                        // commit('SET_NAME', res.user.orgName)
                    // }

                    commit('SET_AVATAR', 'admin')
                    commit('SET_PERMISSIONS_AUTH', res.permissions)
                    // commit('SET_PERMISSIONS_AUTH', res.permissions)
                }
                resolve(res)
            })
            commit('SET_NAME', 'admin')
            commit('SET_AVATAR', 'admin')
        })
    },

    // user logout
    logout({ commit, state }) {
        return new Promise((resolve, reject) => {
            commit('SET_TOKEN', null)
            commit('SET_TOKENS', '')
            commit('SET_NAME', null)
            commit('SET_AVATAR', null)
            removeToken()
            removeTokens()
            removeSafe()
            resetRouter()
            resolve()
        })
    },
    resetSafe({ commit }) {
        return new Promise(resolve => {
            commit('SET_SECURITY', '')
            removeSafe()
        })
    },
    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_TOKENS', '')
            removeToken()
            removeTokens()
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

